import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/99talk-app-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-26475118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service__inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image__src",
    src: _imports_0,
    alt: "chevron-forward"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item__name" }, " 비즈플랫-구구톡 "),
  /*#__PURE__*/_createElementVNode("div", { class: "item__description" }, " 플랫폼 인큐베이터 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon__src",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "40",
      d: "M184 112l144 144-144 144"
    })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "serviceContainer",
    class: _normalizeClass(_ctx.serviceContainerStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickItem && _ctx.onClickItem(...args)))
      }, _hoisted_5)
    ])
  ], 2))
}